import {
  CHANGE_THEME_TO_DARK,
  CHANGE_THEME_TO_LIGHT,
} from '../actions/themeActions';

const theme = localStorage.getItem('themeType');

const initialState = {
  className: theme ?? 'theme-light',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CHANGE_THEME_TO_DARK:
      localStorage.setItem('themeType', 'theme-dark');
      return { className: 'theme-dark' };
    case CHANGE_THEME_TO_LIGHT:
      localStorage.setItem('themeType', 'theme-light');
      return { className: 'theme-light' };
    default:
      return state;
  }
}
